/**
* @项目名称: landing-h5
* @功能名称: 平铺注册组件调支付接口
* @文件名称: register
* @Date: 2019/9/8
* @Author: liux
* @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
* 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
*/
<style lang="less" scoped>
    @import "~bjxy-common/helper/util.less";

    .register {
        padding-bottom: 1rem;
        width: 100%;
        position: relative;
        .form {
            padding: 1.25rem .75rem .75rem;
            .input-box {
                position: relative;
                width: 100%;
                margin-top: .5rem;
                .input {
                    width: 100%;
                    height: 2.5rem;
                    line-height: 1.5rem;
                    padding: .5rem 1.1rem;
                    font-size: .8rem;
                    background: #fff;
                    border-radius: 1.25rem;
                    border: 1px solid #d7d7d7;
                }

            }
            .mobile-box {

            }
            .captcha-box {
                .captcha-img {
                    position: absolute;
                    z-index: 1;
                    right: 1.1rem;
                    top: 50%;
                    width: 4.7rem;
                    transform: translateY(-50%);
                }
            }
            .sms-code-box {
                .send-sms-code {
                    position: absolute;
                    z-index: 1;
                    right: 0;
                    top: 0;
                    width: 6.25rem;
                    height: 2.5rem;
                    line-height: 2.5rem;
                    font-size: .8rem;
                    color: #ffa448;
                    text-align: center;
                    display: block;
                    &:before {
                        position: absolute;
                        z-index: 1;
                        left: 0;
                        top: .9rem;
                        width: 1px;
                        height: .7rem;
                        background: #c8c8c8;
                        content: "";
                        display: block;
                    }
                }
            }
            .password-box {

            }
            .invite-box{

            }
            .submit {
                height: 2.5rem;
                line-height: 2.5rem;
                text-align: center;
                font-size: .9rem;
                text-decoration: none;
                margin-top: 1rem;
                background: #fd9a51;
                border-radius: 1.25rem;
                display: block;
                width: 100%;
                color: white;
                &:active {
                    opacity: .8;
                }
            }

            .img-box {
                margin-top: .5rem;
                text-align: center;
                img {
                    width: 100%;
                }
            }
            .agree-box {
                color: #999;
                .agree {
                    float: left;
                    width: auto;
                    margin: .2rem;
                }
                .go-login {
                    margin: .2rem;
                    float: right;
                    text-decoration: underline;
                }
            }
        }

    }

</style>
<template>
    <div class="register">
        <div class="form">
            <div class="input-box mobile-box">
                <input :style="styleObject.input" v-report.change="{buttonid:0,mobile}" v-xreport="{eventName:'shoujihaoshurukuang', actionType: 'element'}" @blur="blur" class="input mobile" type="tel" maxlength="11" autocomplete="off" v-model.trim="mobile" name="mobile" placeholder="请输入手机号">
            </div>
            <div class="input-box sms-code-box">
                <input :style="styleObject.input" v-report="{buttonid:3}" v-xreport="{eventName:'duanxinyanzhengmashurukuang', actionType: 'element'}"  class="input sms-code" type="tel" maxlength="4" autocomplete="off" v-model="smsCode" name="smscode" placeholder="请输入验证码">
                <a v-if="count>0" class="send-sms-code">{{count}}s</a>
                <a :style="styleObject.sendSmsCode" v-report="{buttonid:2}" v-xreport="{eventName:'huoquyanzhengma', actionType: 'element'}" v-else class="send-sms-code" @click="sendSmsCode">获取验证码</a>
            </div>
            <div class="input-box password-box" v-if="showPassword && isShowInput">
                <input :style="styleObject.input" v-report="{buttonid:4}" v-xreport="{eventName:'mimashurukuang', actionType: 'element'}" type="password" maxlength="16" autocomplete="off" name="password" v-model="password" class="input password"
                       placeholder="请设置登录密码">
            </div>
            <div class="input-box invite-box" v-if="extend.isShowInvite==1 && isShowInput">
                <input :style="styleObject.input" class="input invite" v-report="{buttonid:5}"  v-model.trim="inviteMobile"  type="tel"  maxlength="11" placeholder="输入邀请人手机号（选填）">
            </div>
            <button :style="styleObject.submit" v-report="{buttonid:6}" v-xreport="{eventName:'lijizhuce', actionType: 'element'}" class="submit" @click="submit">{{submitBtnText}}</button>
            <div class="img-box" v-if="extend.isImgReg==1">
                <img src="./img/img.png" alt="">
            </div>

            <div :style="styleObject.agreeBox" class="agree-box clear">
                <agree class="agree" :checked.sync="checked">
                    <p><span @click="checked = !checked">我已阅读并同意</span>
                        <a v-for="item of contracts" @click="open(item)">{{item.contractTitle}} </a>
                    </p>
                </agree>
                <a class="go-login" v-if="extend.existing==1" v-report="{buttonid:7,mobile}" v-xreport="{eventName:'yiyouzhanghuwenzilian', actionType: 'element'}" @click="showLogin">已有帐号，登录</a>
            </div>
        </div>
        <keep-alive>
            <login :config="config" :user-info="userInfo" @userInfo="updateUserInfo" ref="login"></login>
        </keep-alive>
    </div>
</template>

<script>
import agree from '../agree'
import login from '../payLogin'
import getQueryString from 'bjxy-common/helper/getQueryString'
import getQueryJson from 'bjxy-common/helper/getQueryJson'
import addUrlQuery from 'bjxy-common/helper/addUrlQuery'
import md5Fun from 'bjxy-common/helper/md5Fun'
import { mixin, api, dict } from '../utils'
import rmNull from 'bjxy-common/helper/rmNull'
import getSmsTpl from '../utils/getSmsTplId'
import replaceDomain from 'bjxy-common/xyHelper/replaceDomain'
import getGeetest from '../utils/getGeetest'
import throttle from '../utils/throttle'
import cookieKeyword from '../utils/cookieKeyword'
import { bindWechat } from '@/component/utils/bindWechat'
import getBrowserInfo from 'bjxy-common/helper/getBrowserInfo'
import reportDupRegisterMix from '../utils/reportDupRegisterMix'
const ua = getBrowserInfo()

const isDevProxy = process.env.VUE_APP_PROXY === 'proxy'

export default {
  data () {
    return {
      count: 0,
      mobile: '',
      inviteMobile: '', // 邀请人手机号可以不填
      inviterUid: getQueryString('inviterUid'),
      checked: false,
      smsCode: '',
      password: '',
      source: getQueryString('source'),
      contracts: [{ contractTitle: '' }],
      regInfo: {
        // orderId: "170571700214956099",
        // verifyId: "2293817bf5864302841189b3b6e4e5db"
      }
    }
  },
  props: {
    config: {
      type: Object,
      default: function () {
        return {
          extend: {},
          templateId: '',
          regType: '',
          landId: ''
        }
      }
    },
    prefixPage: {
      type: String,
      default: ''
    }
  },
  computed: {
    styleObject () {
      return {
        input: rmNull({
          borderRadius: this.extend.border_radius,
          border: this.extend.is_border
        }),
        submit: rmNull({
          borderRadius: this.extend.border_radius,
          border: this.extend.is_border,
          color: this.extend.but_color,
          backgroundColor: this.extend.but_bg
        }),
        sendSmsCode: rmNull({
          color: this.extend.code_color
        }),
        agreeBox: rmNull({
          color: this.extend.arg_color
        })
      }
    },
    userInfo: {
      set ({ mobile, password }) {
        this.$nextTick(function () {
          if (/^\d{1,11}$/.test(mobile)) {
            this.mobile = mobile
          }
          if (password) {
            this.password = password
          }
        })
      },
      get () {
        return {
          mobile: this.mobile,
          password: this.password
        }
      }
    },
    isRegister () {
      // 支付前置接口不在返回注册状态
      return false
    },
    isShowInput () {
      return !this.isRegister
    },
    submitBtnText () {
      return this.isRegister ? '立即登录' : this.config.buttonCharacters
    },
    showPassword () {
      // 显示密码注册功能下线
      return false
    },
    extend () {
      return this.config.extend
    },
    hasRegRedirect () {
      if (ua.ios) {
        return this.extend.iosHasRegUrl || this.config.hasRegRedirect
      } else if (ua.android) {
        return this.extend.androidHasRegUrl || this.config.hasRegRedirect
      } else {
        return this.config.hasRegRedirect
      }
    },
    productType () {
      return this.extend.productType
    },
    smsTpl () {
      return getSmsTpl(this.productType, this.extend.partnerName)
    },
    regType () {
      return this.extend.regType
    },
    templateId () {
      return this.config.templateId
    },
    sceneId () {
      if (this.extend.contract_type == 1) {
        return 'dyhUserRegister'
      } else {
        return 'userRegister'
      }
    },
    params () {
      var params = {
        source: this.source,
        landId: this.config.landId,
        partner_data: getQueryString('partner_data')
      }
      rmNull(params)
      return params
    }
  },
  mixins: [mixin, reportDupRegisterMix],
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getContract()
      this.reportInit({ cmdid: 65045, buttonid: -1, source: this.source, productType: this.productType })
      this.pageShow({
        eventName: this.prefixPage + 'zhuceluodiye_pingpuluodiye',
        extendEvent: {
          productType: this.productType || ''
        }
      })
    },
    blur () {
      this.xreport('shurushoujihao', { extendEvent: { mobile: this.mobile } })
    },
    // 发送短信验证码
    sendThrottle: throttle(function () {
      getGeetest().then(this.send.bind(this), this.toast.bind(this))
    }, 2000),
    sendSmsCode () {
      if (!this.test({ account: this.mobile })) return
      // 极验
      this.sendThrottle()
    },
    send (result) {
      var template = {
        smsTplId: this.smsTpl.smsTplId,
        smsTplVersion: this.smsTpl.smsTplVersion
      }
      var params = {
        skeyType: dict.skeyType,
        account: this.mobile,
        accountType: 1, // int 必填 1手机号 2邮箱
        version: '1',
        userVerify: JSON.stringify({
          challenge: result.geetest_challenge,
          validate: result.geetest_validate,
          seccode: result.geetest_seccode,
          id: result.id
        }),
        template: JSON.stringify(template)
      }
      if (!this.test(params)) return
      this.post(isDevProxy ? '/form/preRegister' : api.PAY_PRE_REGISTER, params).then(json => {
        if (json.status === 1) {
          this.regInfo = json.data
          if (this.isRegister) {
            this.report({ buttonid: 8, mobile: this.mobile })
            this.xreport('laoyonghutiaozhuan')
          }
          this.countWork(60)
          this.toast('发送短信成功')
        } else {
          this.toast(json.msg)
        }
      })
    },
    // 提交
    submit () {
      this.register()
    },
    // 注册
    register () {
      var dataJson = getQueryJson()
      dataJson.href = location.origin + location.pathname
      var registSource = {
        channel: this.source,
        extendinfo: {
          client: dict.skeyType,
          ua: navigator.userAgent,
          templateId: this.templateId,
          dataJson: dataJson // 支付落库，统计用
        }
      }

      const creditContractIds = this.contracts.map(item => item.creditContractId)
      var params = {
        loginType: 'SMS',
        isSlient: true, // 登录注册合并
        account: this.mobile,
        userVerify: JSON.stringify({
          code: this.smsCode,
          id: this.regInfo.verifyId
        }),
        skeyType: dict.skeyType,
        accountType: 1, // int 必填 1手机号 2邮箱
        ...this.regInfo,
        registSource: JSON.stringify(registSource),
        data: JSON.stringify(rmNull({
          sourceType: this.extend.sourceType || 'landing-h5',
          channel: this.source,
          inviteMobile: this.inviteMobile,
          activityId: this.extend.activityId,
          osType: 'h5',
          mobile: this.mobile,
          productType: this.productType,
          inviterUid: this.inviterUid,
          dataJson: JSON.stringify(dataJson),
          // 注册协议的生成 新增两个字段
          creditContractIds,
          sceneId: this.sceneId,
          templateId: this.templateId,
          ...cookieKeyword,
          userAgent: navigator.userAgent
        })),
        flowExtendInfo: JSON.stringify(rmNull({
          sourceType: this.extend.sourceType || 'landing-h5',
          channelId: this.source,
          mobile: this.mobile,
          activityId: this.extend.activityId,
          osType: 'h5',
          dataJson: JSON.stringify(dataJson),
          ...cookieKeyword
        }))
      }
      if (!this.test({
        ...params,
        checked: this.checked,
        inviteMobile: this.inviteMobile
      })) { return }

      this.post(api.PAY_LOGIN, params).then(json => {
        if (json.status === 1) {
          this.report({ buttonid: 10, mobile: this.mobile })
          this.done(json)
        } else {
          this.toast(json.msg)
          this.$emit('regFail', json)
        }
      })
    },
    done (json) {
      // isRegister: '1' 注册成功，其他情况不返回isRegister
      if (Number(json?.data?.isRegister) === 1) {
        this.xreport('zhucechenggong')
        bindWechat(this.config.openId, () => {
          this.$emit('regDone', json)
        })
      } else {
        this.reportDupRegister()
        this.toast('登录成功，正在为您跳转...')
        this.xreport('dengluchenggong')
        bindWechat(this.config.openId, () => {
          setTimeout(() => {
            location.href = addUrlQuery(replaceDomain(this.hasRegRedirect), this.params)
          }, 500)
        })
      }
    },
    updateUserInfo (obj) {
      this.userInfo = obj
    },
    showLogin () {
      this.xreport('denglutanchuang')
      this.$refs.login.show()
    },
    getContract () {
      this.checked = this.extend.agreementSelected == '1'
      this.post(api.CONTRAST, {
        sceneId: this.sceneId,
        partnerName: this.extend.partnerName,
        productType: this.productType
      }).then(json => {
        this.contracts = json.data.contractScene.contractList
      })
    },
    countWork (count) {
      this.count = count
      var timer = setInterval(() => {
        if (this.count > 0) {
          this.count--
        } else {
          clearInterval(timer)
        }
      }, 1000)
    },

    open (obj) {
      this.report({ buttonid: 9 })
      this.xreport('zhucexieyi')
      setTimeout(() => {
        location.href = replaceDomain(obj.contractUrl)
      }, 50)
      // var src = encodeURIComponent(obj.contractUrl);
      // var title = encodeURIComponent(obj.contractTitle)
      // this.$router.push({name: 'iframe', query: {title: title, src: src}})
    },
    clear () {
      this.count = 0
      this.mobile = ''
      this.inviteMobile = ''
      this.smsCode = ''
      this.password = ''
    }
  },
  components: {
    agree,
    login
  }
}
</script>
